module.exports = __webpack_public_path__ + "static/media/accepted.830fb41f.png";